/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ServiceItem } from './ServiceItem'
import {
  ServiceItemFromJSON,
  ServiceItemFromJSONTyped,
  ServiceItemToJSON,
} from './ServiceItem'

/**
 *
 * @export
 * @interface GetServicesCategory200Response
 */
export interface GetServicesCategory200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetServicesCategory200Response
   */
  status: boolean
  /**
   *
   * @type {ServiceItem}
   * @memberof GetServicesCategory200Response
   */
  data: ServiceItem
}

/**
 * Check if a given object implements the GetServicesCategory200Response interface.
 */
export function instanceOfGetServicesCategory200Response(
  value: object
): value is GetServicesCategory200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetServicesCategory200ResponseFromJSON(
  json: any
): GetServicesCategory200Response {
  return GetServicesCategory200ResponseFromJSONTyped(json, false)
}

export function GetServicesCategory200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetServicesCategory200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: ServiceItemFromJSON(json['data']),
  }
}

export function GetServicesCategory200ResponseToJSON(
  value?: GetServicesCategory200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: ServiceItemToJSON(value['data']),
  }
}
